export default function getOrdinalSuffix(day: number): string {
  if (day > 3 && day < 21) return 'th'; // covers 4th to 20th
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}
